import {IconicGTMPurchase} from './gtm-purchase.js';

/**
 * Handle post-purchase AffiliateWP event.
 */
class IconicAffWPPurchase {
	/**
	 * Check is purchase response is a trial.
	 *
	 * @param response
	 * @returns {boolean}
	 */
	static pushReferral = ( response, title = '' ) => {
		let data = {
			'action': 'iconic_aff_ajax_referral',
			'nonce': iconicVars.nonce,
			'amount': IconicGTMPurchase.responseGetTotal( response ),
			'description': title + ' [plan:' + IconicGTMPurchase.responseGetPlanId( response ) + '] [license:' + IconicGTMPurchase.responseGetLicenseId( response ) + ']',
			'reference': IconicGTMPurchase.responseGetTransactionId( response )
		};

		// Send request to get MD5 hash and formatted data.
		jQuery.post( iconicVars.ajaxUrl, data, function( response ) {
			if ( !response.success ) {
				console.log( 'Affiliate tracking failed.' );
				return;
			}

			let ref = jQuery.cookie( 'affwp_ref' ),
				visit = jQuery.cookie( 'affwp_ref_visit_id' );

			// If a referral var is present and a referral cookie is not already set
			if ( ref && visit ) {
				// Fire an ajax request to log the hit
				jQuery.ajax( {
					type: "POST",
					data: {
						action: 'affwp_track_conversion',
						affiliate: ref,
						amount: response.data.amount,
						status: response.data.status,
						description: response.data.description,
						context: response.data.context,
						reference: response.data.reference,
						campaign: response.data.campaign,
						type: response.data.type,
						md5: response.data.md5
					},
					url: iconicVars.ajaxUrl,
					success: function( response ) {
						if ( window.console && window.console.log ) {
							console.log( response );
						}
					}
				} ).fail( function( response ) {
					if ( window.console && window.console.log ) {
						console.log( response );
					}
				} ).done( function( response ) {
				} );
			}
		} );
	};
}

export {IconicAffWPPurchase};